import mCommentCard1 from "../../Comment/Card/CommentCard1";

export const Card = {
    mCommentCard1,
}